module.exports = __webpack_public_path__ + "static/media/Mini_BallSell.11db73cb.png";